import { useRef } from "react";
import { Html } from "@react-three/drei";
import panoIcon from "../../static/images/panorama.png";

function PanoSpot({
	panoSpot,
	selectObject,
	isPreviewComponent,
	setIsPanoSpotOpen,
	setPanoSpotDetails,
}) {
	const mesh = useRef(null);
	const onClickHandler = () => {
		if (!isPreviewComponent) {
			setIsPanoSpotOpen(true);
			setPanoSpotDetails({ url: panoSpot.url, name: panoSpot.name });
		} else {
			selectObject(panoSpot, mesh.current);
		}
	};
	console.log("Pano: ", panoSpot);
	return (
		<mesh position={panoSpot.position} ref={mesh}>
			<Html center zIndexRange={[100, 10]}>
				<img
					className="infoTextspot"
					src={panoIcon}
					alt="infospot"
					width="35px"
					height="35px"
					onClick={(e) => {
						onClickHandler();
					}}
				/>
			</Html>
		</mesh>
	);
}
export default PanoSpot;
